<div class="custom-control custom-checkbox">
  <input
    [id]="identifier"
    [name]="name"
    type="checkbox"
    class="custom-control-input"
    [ngClass]="
      hasRequiredError() || hasEqualTrueError()
        ? 'is-invalid'
        : touched
        ? 'is-valid'
        : ''
    "
    [(ngModel)]="value"
    [value]="set"
    [checked]="value == set"
    [placeholder]="placeholder"
    #control="ngModel"
    [required]="required == 'true' || required == '' ? '' : undefined"
    (blur)="onTouched()"
    [readonly]="readonly"
    [disabled]="disabled"
    [attr.aria-required]="isRequired"
    [attr.aria-describedby]="isShowErrors ? identifier + '-feedbacks' : null"
  />
  <label
    *ngIf="isHtmlLabel == false"
    class="custom-control-label"
    [for]="identifier"
  >
    <span [innerText]="labelText"></span>
    <span
      *ngIf="hasRequiredValidator()"
      class="custom-checkbox-required-start"
      [innerText]="'*'"
    ></span>
  </label>

  <label *ngIf="isHtmlLabel" class="custom-control-label" [for]="identifier">
    <span [innerHTML]="evaluatedHtmlLabel"></span>
    <span
      *ngIf="hasRequiredValidator()"
      class="custom-checkbox-required-start"
      [innerText]="'*'"
    ></span>
  </label>

  <small
    [id]="identifier + 'Help'"
    *ngIf="helpText"
    class="form-text text-muted"
    [innerText]="helpText"
  ></small>

  <ng-container *ngTemplateOutlet="feedback"> </ng-container>
</div>

<ng-template #feedback>
  <ng-container *ngIf="isShowErrors">
    <div [id]="identifier + '-feedbacks'" class="invalid-feedback" role="alert">
      <div
        *ngFor="let error of errors; trackBy: trackByMessageKey"
        [innerText]="
          key + '.' + error.messageKey | translate : error.messageArgs
        "
      ></div>
    </div>
  </ng-container>
</ng-template>
